import { FREE_SKUS } from "../../../constants/freeProducts";

// If there is a PURL code in the url
export const purlDetected = () => window.location.search.includes("purl");
// Skus for current purl items
export const isPurlItem = (sku) =>
  [
    "CP-FREE_MAG-3X2-0000-001",
    "CP-FREE_MAG-2X3-0000-002",
    "CP-PHOTOS-4X6-0000-001",
    "CP-PHOTOS-6X4-0000-001",
    "CP-STK25-CIRC-2X2-001",
  ].includes(sku);

// If item is a valid free item
export function isFreeItem(selectedProduct) {
  let isFree = false;

  // Don't default to a free product unless purl is detected
  if (!purlDetected()) {
    return false;
  }

  if (selectedProduct.hasOwnProperty("variants")) {
    // Convert the SKU to uppercase because sometimes it gets mis-typed
    isFree = FREE_SKUS.includes(selectedProduct.variants[0].sku.toUpperCase());
  }

  return isFree;
}

// Title for promo products
export function freeTitle(selectedProduct) {
  if (!purlDetected()) {
    return false;
  }

  if (selectedProduct.variants[0].sku == "CP-CAN-8X8-0000-001") {
    return "FREE 8x8 Canvas Print";
  } else if (selectedProduct.variants[0].sku == "CP-MUG-BASIC-0000-001") {
    return "FREE 11oz Coffee Mug";
  } else if (selectedProduct.variants[0].sku == "CP-TOTE-BASIC-0000-001") {
    return "FREE Tote Bag";
  } else {
    return selectedProduct.title;
  }
}
